'use client'

import dynamic from 'next/dynamic'

const AccessTracker = dynamic(() => {
    return import("bwax-ui/components/AccessTracker")
}, { 
    ssr: false
})

export default function AccessTrackerClient() {
    return <AccessTracker />
}

